import { useDebounce } from "@utils/debounce";
import React, { useEffect, useState } from "react";
import {
  Alert,
  SectionList,
  View,
  StyleSheet,
  InteractionManager,
  StatusBar,
} from "react-native";
import simpleContacts from "react-native-allcontacts";
import {
  check,
  openSettings,
  PERMISSIONS,
  request,
  RESULTS,
} from "react-native-permissions";
import ProgressDialog from "react-native-progress-dialog";
import { useDispatch, useSelector } from "react-redux";
import { ORDER_FLOW_EVENTS } from "@constants/analyticsEventsCT";
import { actions } from "@reducers/cartReducer";
import { actions as customerActions } from "@reducers/customerReducer";
import analytics from "@services/analytics";
import metrics from "@constants/metrics";
import SearchBar from "@components/SearchBar";
import t from "@constants/localization";
import useCartActions from "../../components/CMS/useCartActions";
import { AapkeContactsHeader } from "../../components/Customer/AapkeContactsHeader";
import { BottomStrip } from "../../components/Customer/BottomStrip";
import { CustomerRow, Seprator } from "../../components/Customer/CustomerRow";
import { Header } from "../../components/Customer/Header";
import ModalLoader from "../../components/ModalLoader";
import { CUSTOMERS_CONTACTS } from "../../constants/strings";
import { createTlUser, getAllTeamLeaderUsers } from "../../services/api";
import {
  checkConatctPermission,
  getJsonData,
  removeDuplicates,
  saveJsonData,
  transformContactsArray,
} from "../../utils/commonFunctions";
import testIds from "@constants/testIds";
import useLeaderState from "@hooks/useLeaderState";

const PATH = "screens/Customer/Customer";

let tempdata = [
  { title: t(`${PATH}/yourCustomer`), data: [] },
  { title: t(`${PATH}/yourContacts`), data: [] },
];
let selfData;
let fromCustomer;
let sku_id;
const Customer = (props) => {
  const [allUsers, setAllUsers] = useState(tempdata);
  const [hasContactPermission, setHasContactPermission] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [refreshList, setRefreshList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateIsLoading, setUpdateIsLoading] = useState(false);
  const dispatch = useDispatch();

  const debounceSearchTerm = useDebounce(searchText, 100);

  const { user } = useSelector((state) => ({
    user: state.auth.user,
    fetching: state.cart.fetching,
  }));

  const { canLeaderUseApp } = useLeaderState();
  const is_suspended =
    user?.is_suspended || user?.leader_state === "LEADER_SUSPENDED";

  useEffect(() => {
    filterSearch(searchText);
  }, [debounceSearchTerm]);

  useEffect(() => {
    return () => {
      tempdata = [
        { title: t(`${PATH}/yourCustomer`), data: [] },
        { title: t(`${PATH}/yourContacts`), data: [] },
      ];
      selfData = sku_id = fromCustomer = null;
    };
  }, []);

  // const { addCart } = useCartActions();

  useEffect(() => {
    fromCustomer = props.route.params?.fromCustomer ?? false;
    sku_id = props.route.params?.sku_id ?? false;
    selfData = {
      user_id: user.user_id,
      user_phone: `+91 - ${user.phone_number}`,
      user_name: t(`${PATH}/forYourself`),
    };
    InteractionManager.runAfterInteractions(() => {
      checkPermission();
      setTimeout(() => {
        getAllContacts();
      }, 400);
    });
  }, []);

  const checkPermission = async () => {
    const hasContactPermission = await checkConatctPermission();
    if (hasContactPermission) {
      setHasContactPermission(true);
    } else {
      setHasContactPermission(false);
    }
  };

  // Function for getting all contacts from contact book
  const getAllContacts = async () => {
    // Checking for contact permission
    if (!(await getJsonData(CUSTOMERS_CONTACTS))) {
      getContacts(addCustomers);
    } else {
      const users = await getJsonData(CUSTOMERS_CONTACTS);
      // users[0].data.sort((a, b) => a.user_name.localeCompare(b.user_name))
      // users[1].data.sort((a, b) => a.user_name.localeCompare(b.user_name))
      tempdata = users;

      setAllUsers(users);
      getAllCustomers();
    }
  };
  const getContacts = async (func) => {
    try {
      const permissionType = await check(PERMISSIONS.ANDROID.READ_CONTACTS);
      let permissionStatus = permissionType;
      if (
        permissionStatus === "NOT_REQUESTED" ||
        permissionStatus === RESULTS.DENIED
      ) {
        permissionStatus = await request(PERMISSIONS.ANDROID.READ_CONTACTS);
      }

      if (permissionStatus === RESULTS.BLOCKED) {
        Alert.alert(
          t(`${PATH}/goToSettings`),
          t(`${PATH}/askForPermission`),
          [
            {
              text: "OK",
              onPress: () =>
                openSettings().catch(() => console.log("cannot open settings")),
            },
          ],
          { cancelable: true },
        );
      }

      if (permissionStatus === RESULTS.GRANTED) {
        setUpdateIsLoading(true);
        func();

        setHasContactPermission(true);
        analytics.trackEvent(ORDER_FLOW_EVENTS.CONTACT_PERMISSION_GRANTED);
      } else {
        setUpdateIsLoading(true);
        getAllCustomers();
        setUpdateIsLoading(false);
        setHasContactPermission(false);
        analytics.trackEvent(ORDER_FLOW_EVENTS.CONTACT_PERMISSION_REJECTED);
      }
    } catch (error) {
      setUpdateIsLoading(false);
      console.log(error);
    }
  };

  // function to get all contact from phonebook and save it to asyncstorage
  const addCustomers = () => {
    getAllCustomers();
    simpleContacts.getContacts().then(async (contacts) => {
      const cont = [
        { title: t(`${PATH}/yourCustomer`), data: tempdata[0].data },
        {
          title: t(`${PATH}/yourContacts`),
          data: transformContactsArray(contacts),
        },
      ];
      tempdata = cont;
      const { length } = tempdata;
      tempdata[length - 1].data = removeDuplicates(
        tempdata[length - 1].data,
        tempdata[0].data,
      );

      setAllUsers(tempdata);

      await saveJsonData(CUSTOMERS_CONTACTS, tempdata);
      setRefreshList(!refreshList);
    });
  };

  const getAllCustomers = () => {
    try {
      getAllTeamLeaderUsers()
        .then(async (response) => {
          setUpdateIsLoading(false);
          try {
            const { length } = tempdata;
            tempdata[length - 1].data = removeDuplicates(
              tempdata[length - 1].data,
              response.data,
            );
            tempdata[0].data = response.data;
            setAllUsers(tempdata);
            setRefreshList(!refreshList);
            await saveJsonData(CUSTOMERS_CONTACTS, tempdata);
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const placeOrder = (item) => {
    try {
      if (sku_id) {
        setIsLoading(true);

        addCart(sku_id, item.user_id, () => {
          analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_ADDED, {
            ...props.route.params,
          });
          dispatch(customerActions.setSelectedContact(item));
          props.navigation.goBack();
          setIsLoading(false);
        });
      } else {
        setIsLoading(true);
        dispatch(
          actions.viewCartLiteSuccess(
            { cartTotal: {}, result: [] },
            item.user_id,
          ),
        );
        dispatch(actions.viewCartLiteRequest(item));
        dispatch(customerActions.setSelectedContact(item));

        setIsLoading(false);
        props.navigation.goBack();
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const addUserApi = (item, section, index) => {
    setIsLoading(true);
    if (section.title === t(`${PATH}/yourContacts`)) {
      createTlUser({
        userCreds: {
          priority: 1,
          user_id: item.user_id,
          name: item.user_name,
          phone_number: item.user_phone,
        },
      })
        .then(async (response) => {
          if (response.status === 200) {
            const res = response.data;
            const body = {
              user_id: res.user_id,
              user_phone: res.user_phone,
              user_name: res.user_name,
              saved: true,
            };
            tempdata[1].data.splice(index, 1);
            tempdata[0].data.push(body);

            setAllUsers(tempdata);
            analytics.trackEvent(ORDER_FLOW_EVENTS.CX_SELECTED, {
              cx_id: res.user_id,
              cx_name: res.user_name,
              source: "Contacts",
            });
            analytics.trackEvent(ORDER_FLOW_EVENTS.NEW_CX_ADDED, {
              source: "Contacts",
            });
            // placeOrder(item)

            setRefreshList(!refreshList);
            await saveJsonData(CUSTOMERS_CONTACTS, tempdata);
            if (fromCustomer) {
              props.navigation.goBack();
            } else {
              // placeOrder(body);
            }
          } else {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } else {
      analytics.trackEvent(ORDER_FLOW_EVENTS.CX_SELECTED, {
        cx_id: item.user_id,
        cx_name: item.user_name,

        source: "My_Cx",
      });

      placeOrder(item);
    }
  };

  const resyncMerge = async () => {
    simpleContacts.getContacts().then(async (contacts) => {
      try {
        const ind = allUsers.length - 1;
        const contact = transformContactsArray(contacts);

        for (let i = 0, l = contact.length; i < l; i++) {
          for (let j = 0, ll = tempdata[ind].data.length; j < ll; j++) {
            if (
              contact[i].user_id === tempdata[ind].data[j].user_id &&
              contact[i].saved !== tempdata[ind].data[j].user_id
            ) {
              contact.splice(i, 1, tempdata[ind].data[j]);
              break;
            }
          }
        }

        tempdata[ind].data = removeDuplicates(contact, tempdata[0].data);

        setAllUsers(tempdata);

        await saveJsonData(CUSTOMERS_CONTACTS, tempdata);
        setUpdateIsLoading(false);
        setRefreshList(!refreshList);
      } catch (error) {
        setUpdateIsLoading(false);
        console.log(error);
      }
    });
  };

  const filterSearch = (text) => {
    const filteredData = tempdata[0].data.filter((item) => {
      const itemData =
        (typeof item.user_name === "string"
          ? item.user_name.toUpperCase()
          : item.user_name) ?? "";
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    });
    const filteredData1 = tempdata[1].data.filter((item) => {
      const itemData =
        (typeof item.user_name === "string"
          ? item.user_name.toUpperCase()
          : item.user_name) ?? "";
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    });

    setAllUsers([
      { title: t(`${PATH}/yourCustomer`), data: filteredData },
      { title: t(`${PATH}/yourContacts`), data: filteredData1 },
    ]);
  };

  const renderItem = ({ item, index, section }) =>
    section.title === t(`${PATH}/yourCustomer`) && fromCustomer ? null : (
      <CustomerRow
        customer={fromCustomer}
        showIcon={section.title === t(`${PATH}/yourContacts`)}
        orderClick={() => {
          addUserApi(item, section, index),
            analytics.trackEvent(ORDER_FLOW_EVENTS.PLACE_ORDER_CLICKED, {
              screen: "CxSelect",
            });
        }}
        disabled={!!is_suspended}
        data={item}
      />
    );

  const _ListHeaderComponent = () =>
    !searchText && !fromCustomer ? (
      <CustomerRow
        orderClick={() => {
          // placeOrder(selfData),
          analytics.trackEvent(ORDER_FLOW_EVENTS.PLACE_ORDER_CLICKED, {
            screen: "CxSelect",
          });
        }}
        disabled={is_suspended}
        data={{
          user_phone: `+91 - ${user.phone_number}`,
          user_name: t(`${PATH}/forYourself`),
        }}
      />
    ) : null;

  const handleAddCustomer = () => {
    if (!canLeaderUseApp()) {
      return;
    }
    fromCustomer
      ? props.navigation.navigate("AddCustomer", { fromCustomer: true })
      : props.navigation.navigate("AddCustomer", { sku_id });
  };

  return (
    <View testID={testIds.Customer_Select_Kare_Screen} style={{ flex: 1 }}>
      <StatusBar barStyle="dark-content" />
      <ModalLoader loading={isLoading} />
      <ProgressDialog
        labelStyle={{ fontSize: 14 }}
        label={t(`${PATH}/updatingCustomerList`)}
        visible={updateIsLoading}
      />
      <Header
        onBackClick={() => props.navigation.goBack()}
        isBtn={true}
        addContactPress={handleAddCustomer}
        title={t(`${PATH}/selectCustomer`)}
      />
      <SearchBar
        clearSearch
        customStyles={styles.searchContainer}
        query={searchText}
        placeholder={t(`${PATH}/searchCustomer`)}
        shouldShowIcon
        handleQueryChange={(value) => setSearchText(value)}
        onPressRightIcon={() => setSearchText("")}
      />
      <View style={{ flex: 1 }}>
        <SectionList
          removeClippedSubviews
          sections={allUsers}
          extraData={refreshList}
          keyExtractor={(item, index) => item + index}
          ItemSeparatorComponent={({ section: { title } }) =>
            title === t(`${PATH}/yourCustomer`) && fromCustomer ? null : (
              <Seprator />
            )
          }
          renderItem={renderItem}
          ListHeaderComponent={_ListHeaderComponent}
          renderSectionHeader={({ section: { title, data } }) =>
            title === t(`${PATH}/yourCustomer`) && fromCustomer ? null : (
              <AapkeContactsHeader
                btnPress={() => {
                  getContacts(resyncMerge),
                    analytics.trackEvent(ORDER_FLOW_EVENTS.CONTACT_SYNCED);
                }}
                isBtn={title === t(`${PATH}/yourContacts`)}
                title={title}
                btnText={t(`${PATH}/update`)}
              />
            )
          }
        />
      </View>
      {!hasContactPermission ? (
        <BottomStrip
          onPress={() => {
            getContacts(resyncMerge),
              analytics.trackEvent(ORDER_FLOW_EVENTS.CONTACT_SYNCED);
          }}
          title={t(`${PATH}/addCustomerFromContacts`)}
        />
      ) : null}
    </View>
  );
};
export default Customer;

const styles = StyleSheet.create({
  searchContainer: {
    padding: metrics.baseGutter,
    backgroundColor: "#fff",
  },
});
